import { render, staticRenderFns } from "./FourOverArtworkStep.vue?vue&type=template&id=f7d56c2c"
import script from "./FourOverArtworkStep.vue?vue&type=script&lang=js"
export * from "./FourOverArtworkStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports